module.exports = __webpack_public_path__ + "img/vietnam.d4ed750c.svg";